import type { SwipeTranslation } from '@lotta/shared/types-lottery-schemas';
import { useCallback } from 'react';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import readXlsxFile from 'read-excel-file';
import { FileUploadButton } from '../../components/file-upload-button/FileUploadButton';

type UploadSwipeQuestionsProps = {
  handleQuestions: (questions: SwipeTranslation['questions'], fileName: string) => void;
  handleError: (error: FieldError) => void;
};

export const UploadSwipeQuestions: React.FC<UploadSwipeQuestionsProps> = ({
  handleQuestions,
  handleError,
}) => {
  const { t } = useTranslation();

  const handleFileUpload = useCallback(
    async (file: File) => {
      try {
        const rows = await readXlsxFile(file);
        // First row should be the labels - ignore it
        const questions = rows
          .slice(1)
          .map(([question, description, correctAnswerText, wrongAnswerText, answer, image]) => ({
            question: question.toString(),
            description: description.toString(),
            correctAnswerText: correctAnswerText ? correctAnswerText.toString() : undefined,
            wrongAnswerText: wrongAnswerText ? wrongAnswerText.toString() : undefined,
            answer: answer.toString().toUpperCase() === 'TRUE',
            image: image.toString(),
          }));
        handleQuestions(questions, file.name);
      } catch (err) {
        handleError({ type: 'custom', message: 'swipe-upload-questions-error' });
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    [handleQuestions, handleError]
  );

  return (
    <FileUploadButton
      type="secondary"
      accept=".xlsx"
      label={t('swipe-upload-questions-xlsx-button')}
      onUploadFile={handleFileUpload}
      data-testid="upload-swipe-questions"
    />
  );
};
